import API from 'src/api'
import { http } from 'src/boot/axios'

export default {
  GRAPHQL_URL: `${API.GRAPHQL_URL}photosGallery`,
  GRAPHQL_URL_II: `${API.GRAPHQL_URL}gallery`,
  fetch (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.GRAPHQL_URL}`, payload)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  },
  fetchSprintById (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL_II}/sprints/by-locations/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchTaskPhotosById (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL_II}/sprints/task/photos/${id}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchTaskPhotosByGroup ({ sprintPlanId, taskGroup, locationId }) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL_II}/sprints/task/photos/${sprintPlanId}/${taskGroup}/${locationId}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchTaskPhotosByGroupAndUser ({ sprintPlanId, taskGroup, userId }) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL_II}/sprints/task/photos/${sprintPlanId}/${taskGroup}/user/${userId}`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchFormsGallery () {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL_II}/forms/`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchFormById (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.GRAPHQL_URL_II}/forms/${payload.id}`, payload)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  },
  fetchFormPhotosById (payload) {
    return new Promise((resolve, reject) => {
      http.get(`${this.GRAPHQL_URL_II}/forms/ocurrence/${payload.occurrence_id}/item/${payload.item_id}/photos`)
        .then(res => {
          resolve(res.data)
        })
        .catch(error => { reject(error) })
    })
  }
}
